import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './HomeList.css';
import { useNavigate } from 'react-router-dom';
import MainNavbar from '../MainNavbar';
import SubscriptionModal from './SubscriptionModal';
import Chatroom from '../Chating/Chatroom'; // Import the Chatroom component
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faPrayingHands,
  faUsers,
  faBriefcase,
  faEye,
  faTrashAlt,
  faChevronLeft,
  faChevronRight,
  faHeart,
} from "@fortawesome/free-solid-svg-icons";
import { GiPartyPopper } from "react-icons/gi";
import { IoMdClose } from 'react-icons/io';
import Select from 'react-select';
import { FiUser, FiUserCheck } from "react-icons/fi";
import { FaGem, FaMedal, FaStar, FaCircle } from 'react-icons/fa';
import {
  GiCheckedShield,
  GiMetalBar,
  GiGoldBar,
  GiTrophyCup,
  GiCutDiamond
} from 'react-icons/gi';
import { Helmet } from "react-helmet";
import { useContext } from "react";
import AlertContext from "../../../contexts/AlertContext";

const HomeList = ({ }) => {
  const [profiles, setProfiles] = useState([]);
  const [currentUser, setCurrentUser] = useState({ userId: '', gender: '', name: '' });
  const [selectedProfiles, setSelectedProfiles] = useState([]);
  const [shortlistedUsers, setShortlistedUsers] = useState([]);
  const [error, setError] = useState(null); // Add this line
  const [isOpen, setIsOpen] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [matchScores, setMatchScores] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFetched, setStatusFetched] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [planInfo, setPlanInfo] = useState([]);
  const navigate = useNavigate();
  const [selectedReligion, setSelectedReligion] = useState("");
  const [selectedReligions, setSelectedReligions] = useState([]);
  const { showAlert } = useContext(AlertContext);

  const religionContent = {
    Hindu: {
      title: "Tamil Hindu Matrimony",
      text: "Find the perfect Tamil Hindu match from communities like Iyer, Iyengar, Nadar, Mudaliar, Gounder, and Vanniyar. Varankal ensures cultural compatibility with modern convenience."
    },
    Christian: {
      title: "Tamil Christian Matrimony",
      text: "Connect with verified Christian profiles from Catholic, CSI, Pentecostal, and Orthodox backgrounds. Faith and love come together beautifully here."
    },
    Muslim: {
      title: "Tamil Muslim Matrimony",
      text: "Respectful, private, and genuine — our Tamil Muslim Matrimony service helps you find a life partner who values faith and family."
    }
  };



  const getUniqueOptions = (profiles, key) => {
    const seen = new Map();

    profiles.forEach(profile => {
      const rawValue = profile[key]?.trim();
      if (rawValue) {
        const normalized = rawValue.toLowerCase();
        if (!seen.has(normalized)) {
          seen.set(normalized, rawValue); // original casing
        }
      }
    });

    return Array.from(seen.values())
      .map(val => ({ label: val, value: val }))
      .sort((a, b) => a.label.localeCompare(b.label));
  };

  const locationOptions = getUniqueOptions(
    profiles.map(p => ({ location: p.location?.district })),
    'location'
  );

  const religionOptions = getUniqueOptions(profiles, 'religion');
  const casteOptions = getUniqueOptions(profiles, 'caste');
  const occupationOptions = getUniqueOptions(profiles, 'occupation');

  const [filterCriteria, setFilterCriteria] = useState({
    location: [],
    religion: [],
    caste: [],
    occupation: [],
    shortlistedOnly: false
  });


  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    axios
      .get('https://back.varankal.com/app/userreports/all-users-view-usage', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      })
      .then((res) => {
        setPlanInfo(res.data); // res.data is an array of users
      })
      .catch((err) => {
        setError('Unable to fetch all users plan details.');
        console.error(err);
      });
  }, []);


  useEffect(() => {
    const step = localStorage.getItem("profileStep");

    if (step !== "3") {
      setShowProfileModal(true);   // show popup ONLY if not completed
    } else {
      setShowProfileModal(false);  // completed → never show again
    }
  }, []);

  const step = localStorage.getItem("profileStep");

  // Dynamic title based on step
  const stepTitle =
    step === "0"
      ? "Complete Your Basic Registration"
      : step === "1"
        ? "Create Your Profile"
        : step === "2"
          ? "Set Your Partner Preferences"
          : "Profile Completed";


  const buttonText =
    step === "0"
      ? "Free Registration"
      : step === "1"
        ? "Create Profile"
        : step === "2"
          ? "Set Partner Preferences"
          : "Go to Dashboard";


  const toggleSelect = (userId) => {
    setSelectedUsers(prev =>
      prev.includes(userId)
        ? prev.filter(id => id !== userId)
        : [...prev, userId]
    );
  };

  const profilesPerPage = 8;
  const totalPages = Math.ceil(profiles.length / profilesPerPage);

  const iconMap = {
    location: faMapMarkerAlt,
    religion: faPrayingHands,
    caste: faUsers,
    occupation: faBriefcase,
  };


  useEffect(() => {
    document.body.classList.add('body-background');

    return () => {
      document.body.classList.remove('body-background');
    };
  }, []);

  useEffect(() => {
    const fetchData = async (userId) => {
      try {
        // 1. Fetch current user
        const currentUserRes = await axios.get(`https://back.varankal.com/user/currentregister-details/${userId}`, { withCredentials: true });
        const currentUser = {
          userId: currentUserRes.data.userId,
          name: currentUserRes.data.basicDetails.name,
          gender: currentUserRes.data.basicDetails.gender,
        };
        setCurrentUser(currentUser); // Update state

        // 2. Fetch all register data
        const registerResponse = await axios.get('https://back.varankal.com/user/all-register-details', { withCredentials: true });
        // 3. Get shortlisted user IDs
        const shortlistRes = await axios.get('https://back.varankal.com/auth/shortlisted/ids', { withCredentials: true });
        const shortlistedIds = shortlistRes.data.shortlistedIds;
        const registerData = registerResponse.data.reduce((acc, profile) => {
          const shortlistedBy = Array.isArray(profile.shortlistedBy) ? profile.shortlistedBy : [];

          acc[profile.userId] = {
            userId: profile.userId,
            name: profile.basicDetails.name,
            age: profile.basicDetails.age,
            gender: profile.basicDetails.gender,
            profilePicture: profile.basicDetails.profilePicture,
            shortlisted: shortlistedIds.includes(profile.userId),
          };
          return acc;
        }, {});

        // 3. Fetch personal data and merge
        const personalResponse = await axios.get('https://back.varankal.com/user/all-personal-details', { withCredentials: true });
        const personalData = personalResponse.data;

        const mergedData = personalData.map(profile => ({
          ...registerData[profile.userId],
          occupation: profile.occupation,
          religion: profile.religion,
          caste: profile.caste,
          income: profile.userIncome,
          location: profile.location,
        }));

        // ✅ Sort shortlisted profiles to top
        mergedData.sort((a, b) => {
          if (a.shortlisted === b.shortlisted) return 0;
          return a.shortlisted ? -1 : 1;
        });

        setProfiles(mergedData); // ✅ Updated profile list
      } catch (error) {
        console.error('Error fetching user or profiles:', error);
      }
    };

    fetchData();
  }, []);

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilterCriteria(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const applyFilters = (profile) => {
    const {
      location,
      religion,
      caste,
      education,
      occupation,
      shortlistedOnly
    } = filterCriteria;

    const matches = (fieldValue, selectedValues) =>
      !selectedValues.length || selectedValues.includes(fieldValue?.toLowerCase());

    const isShortlisted =
      !shortlistedOnly ||
      shortlistedUsers.some(user => {
        const shortlistedUserId = user.shortlistedUser?._id || user.userId || user._id;
        return shortlistedUserId === profile._id || shortlistedUserId === profile.userId;
      });

    return (
      matches(profile.location?.district?.toLowerCase(), location.map(l => l.toLowerCase())) &&
      matches(profile.religion?.toLowerCase(), religion.map(r => r.toLowerCase())) &&
      matches(profile.caste?.toLowerCase(), caste.map(c => c.toLowerCase())) &&
      matches(profile.occupation?.toLowerCase(), occupation.map(o => o.toLowerCase())) &&
      (currentUser.gender === 'male' ? profile.gender === 'female' : profile.gender === 'male') &&
      isShortlisted
    );
  };


  const filteredProfiles = profiles.filter(applyFilters);


  // const handleProfileClick = async (userId) => {
  //   try {
  //     const response = await axios.get(`https://back.varankal.com/user/view-profile/${userId}`, {
  //       withCredentials: true,
  //     });

  //     if (response.data.profile) {
  //       navigate(`/userpage/${userId}`);
  //     }
  //   } catch (error) {
  //     if (error.response && error.response.status === 403) {
  //       const msg = error.response.data.error;
  //       if (msg === "No active plan found") {
  //         setShowModal(true);
  //       } else {
  //         alert(msg || "Upgrade your plan to view more profiles.");
  //       }
  //     } else {
  //       showAlert("An error occurred while accessing the profile.");
  //     }
  //   }
  // };

  const handleSubscribe = () => {
    setShowModal(false);
    navigate("/subscription");
  };

  const handleProfileClick = (userId) => {
    window.scrollTo(0, 0); // ✅ Scroll to top
    navigate(`/userpage/${userId}`);
    console.log('handleprofile', userId);
  };


  const handleChatClick = async (profile) => {
    const userId = profile.userId;

    if (!userId) {
      showAlert("Invalid profile ID. Cannot start chat.");
      return;
    }

    try {
      const response = await axios.get(`https://back.varankal.com/user/view-profile/${userId}`, {
        withCredentials: true,
      });

      if (response.data.profile) {
        // ✅ User has an active plan — allow chat
        handleMessage(profile);
      }
    } catch (error) {
      // ❌ No plan — show alert
      if (error.response && error.response.status === 403) {
        const msg = error.response.data.error;
        showAlert("Upgrade your plan to chat.");
      } else {
        showAlert("An error occurred while trying to start the chat.");
      }
    }
  };

  // const handleChatClick = (profile) => {
  //   handleMessage(profile); // Directly open chat
  // };


  const handleClear = (field) => {
    setFilterCriteria((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleRequest = async (profile) => {
    try {

      // if (profile.requestStatus === 'Pending' || profile.requestStatus === 'Accepted') {
      //   console.log('Request already sent or accepted');
      //   return;
      // }
      const payload = {
        senderId: currentUser.userId,
        receiverId: profile.userId,
        senderName: currentUser.name,
      };

      // Send request
      await axios.post('https://back.varankal.com/user/requests', payload, { withCredentials: true });
      showAlert('Request sent successfully!');
      // Refresh request status
      await updateRequestStatus(profile.userId);
    } catch (error) {
      console.error('Error sending request:', error.response ? error.response.data : error.message);
    }
  };

  const updateRequestStatus = async (receiverId) => {
    try {
      const statusResponse = await axios.get(
        `https://back.varankal.com/user/request-status/${currentUser.userId}/${receiverId}`,
        { withCredentials: true }
      );

      setProfiles(prevProfiles =>
        prevProfiles.map(p =>
          p.userId === receiverId ? { ...p, requestStatus: statusResponse.data.status } : p
        )
      );
    } catch (error) {
      console.error('Error fetching request status:', error.response ? error.response.data : error.message);
    }
  };

  useEffect(() => {
    const fetchAllStatuses = async () => {
      const updatedProfiles = await Promise.all(profiles.map(async (profile) => {
        try {
          const res = await axios.get(
            `https://back.varankal.com/user/request-status/${currentUser.userId}/${profile.userId}`,
            { withCredentials: true }
          );
          return { ...profile, requestStatus: res.data.status };
        } catch {
          return profile; // Return profile as is if there's an error
        }
      }));

      setProfiles(updatedProfiles);
    };

    // Run fetchAllStatuses only if profiles are available and statuses haven't been fetched yet
    if (profiles.length > 0 && !statusFetched) {
      fetchAllStatuses();
      setStatusFetched(true); // Set the flag to true after the statuses are fetched
    }
  }, [profiles, currentUser.userId, statusFetched, setProfiles]);


  const removeAcceptedRequest = async (receiverId) => {
    const confirmDelete = window.confirm("Are you sure you want to remove this accepted request?");
    if (!confirmDelete) return;
    try {
      const response = await axios.delete(
        `https://back.varankal.com/user/remove-request/${currentUser.userId}/${receiverId}`,
        { withCredentials: true }
      );
      console.log(response.data);
      // Refresh requestStatus after removing
      updateRequestStatus(receiverId);
    } catch (error) {
      console.error('Error removing accepted request:', error);
    }
  };



  const handleMessage = (profile) => {
    if (!selectedProfiles.find(p => p.userId === profile.userId)) {
      setSelectedProfiles([...selectedProfiles, profile]);
    }
  };

  const handleCloseChatroom = (userId) => {
    setSelectedProfiles(selectedProfiles.filter(profile => profile.userId !== userId));
  };

  const handleShortlistToggle = (userId, isShortlisted) => {
    if (isShortlisted) {
      unshortlistUser(userId);
    } else {
      shortlistUser(userId);
    }
  };

  const shortlistUser = async (userId) => {
    try {
      const response = await axios.post(
        `https://back.varankal.com/auth/shortlist/${userId}`,
        { currentUserId: currentUser.userId }, // Ensure you're passing the correct data
        { withCredentials: true }
      );
      console.log('Shortlisted:', response);
      setProfiles(prev =>
        prev.map(p =>
          p.userId === userId ? { ...p, shortlisted: true } : p
        )
      );
    } catch (error) {
      console.error('Error shortlisting user:', error.response ? error.response.data : error.message);
    }
  };


  const unshortlistUser = async (userId) => {

    try {
      const response = await axios.post(
        `https://back.varankal.com/auth/unshortlist/${userId}`,
        { currentUserId: currentUser.userId },
        { withCredentials: true }
      );
      console.log('Unshortlisted:', response);

      // ✅ Update UI
      setProfiles(prev =>
        prev.map(p =>
          p.userId === userId ? { ...p, shortlisted: false } : p
        )
      );

    } catch (error) {
      console.error('Error unshortlisting user:', error);
    }
  };


  const fetchShortlistedUsers = async () => {
    try {
      const response = await axios.get('https://back.varankal.com/auth/shortlisted', { withCredentials: true });
      console.log('Shortlisted Users:', response.data);
      setShortlistedUsers(response.data);
    } catch (error) {
      console.error('Error fetching shortlisted users:', error.response ? error.response.data : error.message);
      setError('Error fetching shortlisted users');
    }
  };

  const removeShortlistUser = async (userId) => {
    const confirmed = window.confirm("Are you sure you want to remove this user from your shortlist?");
    if (!confirmed) return; // If user clicks Cancel, do nothing
    try {
      const response = await axios.delete(
        `https://back.varankal.com/auth/shortlist/remove/${userId}`,
        {
          data: { currentUserId: currentUser.userId }, // Pass body in `data` for DELETE
          withCredentials: true,
        }
      );
      console.log("Removed from shortlist:", response.data);

      // Update local state to reflect removal
      setProfiles((prev) =>
        prev.map((p) =>
          p.userId === userId ? { ...p, shortlisted: false } : p
        )
      );


    } catch (error) {
      console.error(
        "Error removing user from shortlist:",
        error.response ? error.response.data : error.message
      );
    }
  };


  // Call fetchShortlistedUsers when component mounts
  useEffect(() => {
    fetchShortlistedUsers(); // Fetch shortlisted users
  }, [currentUser.userId]);



  useEffect(() => {
    const fetchMatchScores = async () => {
      try {
        const response = await axios.get('https://back.varankal.com/app/userreports/match-score', {
          withCredentials: true
        });
        console.log("Match Scores Response:", response.data); // Debugging log
        setMatchScores(response.data.topMatches || []);
      } catch (error) {
        console.error('Error fetching match scores:', error);
      }
    };

    fetchMatchScores();
  }, []);

  const getMatchScore = (userId) => {
    if (!userId) {
      console.error("No userId provided for profile:", userId); // Log if userId is missing
      return null;
    }
    const match = matchScores.find(m => m.userId && m.userId.toString() === userId.toString());
    console.log("Match for userId", userId, ":", match); // Log the match if found

    return match ? match.matchScore : null;
  };



  return (
    <>
      <MainNavbar />

      <div className="mainprofile">
        <Helmet>
          <title>
            Tamil Matrimony Services | Varankal.com | Hindu, Christian, Muslim, NRI Matches
          </title>
          <meta
            name="description"
            content="Explore Tamil Matrimony Services at Varankal.com – find perfect Tamil Hindu, Christian, Muslim, Elite, and NRI brides and grooms. Verified profiles with 100% privacy."
          />
          <meta
            name="keywords"
            content="Tamil Hindu Matrimony, Tamil Christian Matrimony, Tamil Muslim Matrimony, NRI Tamil Matrimony, Elite Matrimony, Divorcee Matrimony, Tamil Marriage Services, Online Tamil Matrimony"
          />
        </Helmet>
        <>
          {showProfileModal && (
            <div
              className="modal-backdropR"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modalTitleR"
            >
              <div className="modal-boxR animateFadeInR">

                <button
                  className="modal-close-btnR"
                  onClick={() => setShowProfileModal(false)}
                  aria-label="Close modal"
                >
                  <IoMdClose />
                </button>

                <GiPartyPopper className="modal-iconR" />

                {/* 🔥 Dynamic Title */}
                <h2 id="modalTitleR" className="modal-titleR">
                  {stepTitle}
                </h2>

                <p className="modal-descriptionR">
                  To find your perfect match, please complete your profile.
                  This helps us tailor suggestions just for you.
                </p>

                <p className="modal-highlight-noteR">
                  🔒 <strong>Note:</strong> Once you complete the <strong>Registration</strong>,
                  only then you will be able to <strong>view your profile</strong>.
                </p>

                <div className="modal-buttonsR">
                  <button
                    className="modal-buttonR modal-create-btnR"
                    onClick={() => {
                      if (step === "0") navigate("/register");
                      else if (step === "1") navigate("/create");
                      else if (step === "2") navigate("/preference");
                      else navigate("/dashboard");
                    }}
                  >
                    {buttonText}
                  </button>
                </div>

              </div>
            </div>
          )}
        </>

        <div className="profiles-header-title88">
          <h1>
            {selectedReligions.length > 0
              ? `Tamil ${selectedReligions.join(", ")} Matrimony`
              : "Find Your Life Partner"}
          </h1>
        </div>

        <div className="filterjjj">
          <div className="filter-content884">
            <div className="filter-text884">
              <p>
                {selectedReligion && religionContent[selectedReligion]
                  ? religionContent[selectedReligion].text
                  : "Find profiles that match your preferences, lifestyle, interests and compatibility for lasting connections."}
              </p>
            </div>

            <div className="filter-row884">
              {[
                { name: 'location', options: locationOptions },
                { name: 'religion', options: religionOptions },
                { name: 'caste', options: casteOptions },
                { name: 'occupation', options: occupationOptions }
              ].map(({ name, options }) => (
                <div key={name} className="inline-input884">
                  <Select
                    isMulti
                    name={name}
                    options={options}
                    classNamePrefix="select"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    value={options.filter(opt => filterCriteria[name].includes(opt.value))}
                    onChange={selectedOptions => {
                      const selectedValues = selectedOptions.map(opt => opt.value);
                      setFilterCriteria(prev => ({
                        ...prev,
                        [name]: selectedValues
                      }));

                      if (name === "religion") {
                        setSelectedReligions(selectedValues);
                        const lastSelected = selectedValues[selectedValues.length - 1] || "";
                        setSelectedReligion(lastSelected);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}



                    placeholder={
                      <span className="placeholder-icon884">
                        <FontAwesomeIcon icon={iconMap[name]} />
                        <span className="ph-text884">Select {name.charAt(0).toUpperCase() + name.slice(1)}</span>
                      </span>
                    }
                  />
                </div>
              ))}

              <div className="inline-input884">
                <label className="checkbox-label884">
                  <input
                    type="checkbox"
                    checked={filterCriteria.shortlistedOnly}
                    onChange={(e) =>
                      setFilterCriteria(prev => ({
                        ...prev,
                        shortlistedOnly: e.target.checked
                      }))
                    }
                  />
                  <span>Shortlisted</span>
                </label>
              </div>
            </div>
          </div>

        </div>


        <hr></hr>

        <div className="profile-grid88">

          {
            filteredProfiles.length > 0 ? (
              filteredProfiles.map(profile => (


                <div key={profile.userId} className="profile-card88" onClick={() => handleProfileClick(profile.userId)}>

                  <div className="profile-container88">
                    <div className="profile-image-container88">
                      <img
                        src={`data:image/jpeg;base64,${profile.profilePicture}`}
                        alt="Profile"
                        className="profile-image88"
                      />
                      {(() => {
                        const userPlan = planInfo.find(planUser => planUser.userId === profile.userId)?.plan;

                        if (!userPlan) return null;

                        let PlanIcon;

                        switch (userPlan) {
                          case 'Basic':
                            PlanIcon = <GiCheckedShield color="green" size={20} title="Basic Plan" />;
                            break;
                          case 'Silver':
                            PlanIcon = <GiMetalBar color="gray" size={20} title="Silver Plan" />;
                            break;
                          case 'Gold':
                            PlanIcon = <GiGoldBar color="gold" size={20} title="Gold Plan" />;
                            break;
                          case 'Platinum':
                            PlanIcon = <GiTrophyCup color="blue" size={20} title="Platinum Plan" />;
                            break;
                          case 'Diamond':
                            PlanIcon = <GiCutDiamond color="deepskyblue" size={20} title="Diamond Plan" />;
                            break;
                          default:
                            return null;
                        }

                        return (
                          <div className="user-plan88">
                            {PlanIcon}
                          </div>
                        );
                      })()}



                      <div className="profile-overlay88">
                        <div className="profile-row88">
                          <span className="label88">Age</span> <span className="colon88">:</span> <span className="value88">{profile.age}</span>
                        </div>

                        <div className="profile-row88">
                          <span className="label88">Religion</span> <span className="colon88">:</span> <span className="value88">{profile.religion}</span>
                        </div>
                        <div className="profile-row88">
                          <span className="label88">Caste</span> <span className="colon88">:</span> <span className="value88">{profile.caste}</span>
                        </div>

                        {profile.location && (
                          <div className="profile-row88">
                            <span className="label88">Location</span> <span className="colon88">:</span> <span className="value88">{profile.location.district}</span>
                          </div>
                        )}
                        {/* <div className="profile-row88">
                          <span className="label88">Occupation</span> <span className="colon88">:</span> <span className="value88">{profile.occupation}</span>
                        </div> */}
                      </div>
                    </div>


                    <hr className="profile-divideer"></hr>
                    <p className="profile-name88">
                      {getMatchScore(profile?.userId) !== null ? (
                        <span className="match-score88" title='Match Score'>
                          {getMatchScore(profile?.userId)}%
                        </span>
                      ) : (
                        <span className="match-score88" title='Match Score'>0%</span> // Default "0%" if no match score is found
                      )}
                      <strong>{profile?.name} - {profile.age}</strong>
                    </p>
                    <div className="profile-buttons88">

                      {profile.requestStatus === 'Pending' ? (
                        <button disabled>Invite Sent</button>
                      ) : profile.requestStatus === 'Accepted' ? (
                        <button
                          style={{
                            backgroundColor: 'white',
                            color: 'black',
                            border: '1px solid black',
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            removeAcceptedRequest(profile.userId);
                          }}
                        >
                          Accepted
                        </button>

                      ) : profile.requestStatus === 'Rejected' ? (
                        <button onClick={(e) => {
                          e.stopPropagation();
                          handleRequest(profile); // Resend the request
                        }}>
                          Request
                        </button>
                      ) : (
                        <button onClick={(e) => {
                          e.stopPropagation();
                          handleRequest(profile); // Initial request
                        }}>
                          Request
                        </button>
                      )}

                      <div className="shortlist-tooltip-container">
                        {profile.shortlisted ? (
                          <FiUserCheck
                            size={30}
                            color="crimson"
                            className="shortlist-icon"
                            title="Shortlist"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleShortlistToggle(profile.userId, profile.shortlisted);
                              showAlert('Removed from shortlist');
                            }}
                          />
                        ) : (
                          <FiUser
                            size={30}
                            color="gray"
                            className="shortlist-icon"
                            title="Unshortlist"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleShortlistToggle(profile.userId, profile.shortlisted);
                              showAlert('Added to your shortlisted profiles');
                            }}
                          />
                        )}

                        <span className="tooltip-text-shortlist">
                          {profile.shortlisted ? "Shortlisted" : "Shortlist"}
                        </span>
                      </div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleChatClick(profile);
                        }}
                      >
                        Chat
                      </button>
                    </div>
                  </div>



                </div>
              ))
            ) : (
              <p className='texttt88'>Waiting for finding your partner...</p>
            )
          }

        </div>

        {/* <div className="view-payments-paginationAD34">
          <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>
            <FontAwesomeIcon icon={faChevronLeft} /> -- Prev
          </button>

          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index + 1}
              onClick={() => setCurrentPage(index + 1)}
              className={currentPage === index + 1 ? "active-page" : ""}
            >
              {index + 1}
            </button>
          ))}

          <button onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}>
            Next -- <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div> */}
      </div>


      {
        selectedProfiles.length > 0 && selectedProfiles.map(profile => (
          <Chatroom key={profile.userId} currentUser={currentUser} selectedProfile={profile}
            onClose={() => handleCloseChatroom(profile.userId)} />

        ))
      }

    </>
  );
};

export default HomeList;
